var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-display"},[_c('div',{staticClass:"row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v(_vm._s(_vm.field.label))]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_vm._v(_vm._s(_vm.field.value))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50af94bf","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/displays/TextDisplay.vue
// module id = 958
// module chunks = 1